<template>
  <div class="date-component-container" :class="{ 'vc-disabled': disabled }">
    <v-date-picker
      :modelValue="dates"
      @update:modelValue="inputHandler"
      :modelModifiers="{ range: true, string: true }"
      :masks="{ modelValue: 'DD.MM.YYYY' }"
      @dayclick="$emit('dayclick', $event)"
      @popoverDidShow="isDatePickerOpen = true; $emit('isDatePickerOpen', true)"
      @popoverDidHide="isDatePickerOpen = false; $emit('isDatePickerOpen', false)"
      :min-date="minDate"
      :max-date="maxDate"
    >
      <template v-slot="{ togglePopover }">
        <div
          class="date-display"
          :style="dateSelectBoxStyle"
          :class="{ 'datepicker-open': isDatePickerOpen, 'date-picked': dates, 'is-error': isError }"
          @click="togglePopover"
          @mouseenter="isHovered = true"
          @mouseleave="isHovered = false"
        >
          <span class="date-display-left">
            <img
              v-if="!dates"
              class="search-icon-default"
              src="@/assets/restyle/images/shared/icons/filter_search_default.svg"
              alt=""
            />
            <img
              v-if="dates && canClearDate"
              @click.stop="inputHandler(null)"
              src="@/assets/restyle/images/shared/icons/cross_2.svg"
              class="cross"
              alt=""
            >
            <span
              v-if="!dates || !dates?.start"
              class="placeholder-date-range"
            >
              <slot name="placeholder">
                {{ placeholder }}
              </slot>
            </span>
            <span class="date-value" :class="{ 'date-value-gray': isDatePickerOpen }">
              {{ dateInputValue }}
            </span>
          </span>
          <span class="date-display-right" v-if="!dates || !dates?.start">
            <img src="@/assets/restyle/images/shared/icons/date/datepicker.svg" alt=""/>
          </span>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
  export default {
    name: 'DateRangePicker',
    props: {
      dates: {
        default: null,
      },
      dateSelectBoxStyle: {
        default: '',
      },
      minDate: {
        default: undefined,
      },
      maxDate: {
        default: undefined,
      },
      canClearDate: {
        type: Boolean,
        default: true,
      },
      isError: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: 'Дата',
      },
      disabled: {
        type: Boolean
      }
    },
    data() {
      return {
        isHovered: false,
        isDatePickerOpen: false,
      }
    },
    computed: {
      dateInputValue() {
        if (this.dates?.start && this.dates?.end) {
          return `${this.dates.start.split('-').join('.')} - ${this.dates.end.split('-').join('.')}`;
        } else {
          return '';
        }
      }
    },
    methods: {
      inputHandler(dateValue) {
        this.$emit('dateChange', dateValue);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .date-display {
    position: relative;
    bottom: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    width: 360px;
    padding: 12px;
    box-shadow: 0px 2px 8px rgba(23, 21, 55, 0.1);
    border-radius: 5px;
    background-color: $color-restyle-white;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    cursor: pointer;
    background-color: #E1F5F5;
    &:hover {
      outline: 1px solid $color-smartro-green-bright;
      box-shadow: none;
    }
  }

  .date-display-left {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .date-picker {
    color: $color-page-text !important;
  }

  .date-component-container {
    position: relative;
    top: 10px;
  }

  .placeholder-date-range {
    color: $color-gray-text;
  }

  .placeholder-active {
    color: $color-page-text;
  }

  .cross {
    width: 15px;
    height: 15px;
  }

  .datepicker-open {
    outline: 1px solid $color-smartro-green-bright;
  }

  .date-value-gray {
    color: $color-gray-text;
  }

  .date-display-right {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .date-picked {
    outline: 1px solid #466ABF;
    box-shadow: none;
  }

  .is-error {
    outline: 1px solid #EB6363 !important;
    box-shadow: none;
  }

.vc-disabled {
  pointer-events: none;
  opacity: 0.6;
}

</style>